import React from "react";
import OddEven from "./Statistic/OddEven";

export const OddEvenTable = (props) => {

    return (
        <div className="odd-even-table">
            <div className="col header-div-title header-history-light text-uppercase">
                <span className="">{props.t("labels:keno.colorOddEven")}</span>
            </div>
            <div
                className="col no-padding-div-left div-bg-gray lotto6-history-result roulette-history-result fade-in pr-0">


                <div className="bet-grid-container">

                    <table
                        id="keno_result_post"
                        border="1"
                        cellPadding="0"
                        cellSpacing="0"
                        width="100%">
                        <tbody>
                        <OddEven {...props}/>
                        </tbody>

                    </table>

                </div>

            </div>
        </div>
    );
}